import type { LocalePack } from './types.js';

/** Chinese (Simplified — 简体中文) */
export const zh: LocalePack = {
  headerTitle: '照片编辑器',
  headerSubtitle: '轻松编辑您的图像',
  applyButton: '应用',
  cancelButton: '关闭',
  undo: '撤销',
  redo: '重做',
  fullscreen: '全屏',
  fit: '适合',
  zoomTooltip: '缩放 · +/− · 0 适合 · 1 100%',

  emptyStateTitle: '拖放图像或点击上传',
  emptyStateSubtitle: '支持格式：PNG、JPEG、HEIC',

  calloutLabelText: '标签',

  tool: {
    select: '选择',
    crop: '裁剪',
    draw: '绘图',
    eraser: '橡皮擦',
    text: '文字',
    shapes: '形状',
    callout: '标注',
    filters: '滤镜',
    adjust: '调整',
    move: '移动',
    pen: '画笔',
    zoom: '缩放',
    zoomIn: '放大',
    zoomOut: '缩小',
    rotateLeft: '向左旋转',
    rotateRight: '向右旋转',
    flipH: '水平翻转',
    flipV: '垂直翻转',
    reset: '重置',
  },

  shape: {
    circle: '圆形',
    ellipse: '椭圆',
    square: '正方形',
    rectangle: '矩形',
    arrow: '箭头',
    polyline: '折线',
  },

  filter: {
    none: '原图',
    grayscale: '黑白',
    sepia: '棕褐色',
    vintage: '复古',
    cool: '冷色',
    warm: '暖色',
    invert: '反色',
  },

  props: {
    title: {
      draw: '绘图',
      eraser: '橡皮擦',
      text: '文字',
      crop: '裁剪',
      shapes: '形状',
      callout: '标注',
      filters: '滤镜',
      adjust: '调整',
      move: '移动',
    },
    aspectRatio: '长宽比',
    applyCrop: '应用裁剪',
    cancel: '取消',
    shape: '形状',
    preset: '预设',
    resetEffects: '重置效果',
    resetAdjustments: '重置调整',
    deleteSelected: '删除所选',
    colors: '颜色',
    recent: '最近',
    customColor: '自定义颜色',
    brushSize: '画笔大小',
    strokeWidth: '描边宽度',
    opacity: '不透明度',
    eraserSize: '橡皮擦大小',
    fontSize: '字号',
    brightness: '亮度',
    contrast: '对比度',
    saturation: '饱和度',
    blur: '模糊',
    quickActions: '快速操作',
    hintMove: '拖动以平移 · 捏合或滚动以缩放 · 选择工具开始编辑。',
    hintEraser: '在批注上点按或拖动以移除。',
  },
};
